import { ADD_BOOK_INFO, REMOVE_BOOK_INFO } from "./actionTypes";

export const addBookInfo = (bookInfo) => ({
    type: ADD_BOOK_INFO,
    payload: {
        ...bookInfo,
    },
    
});

export const removeBookInfo = (id) => ({
    type: REMOVE_BOOK_INFO,
    payload: id,
});